import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Nosotros from "../pages/nosotros/page";
import Productos from "../pages/productos/page";
import Catalogo from "../pages/catalogo/page";
import Servicios from "../pages/servicios/page";
import Contacto from "../pages/contacto/page";
import Galeria from "../pages/galeria/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/nosotros",
        element: <Nosotros />,
      },
      {
        path: "/productos",
        element: <Productos />,
      },
      {
        path: "/catalogo",
        element: <Catalogo />,
      },
      {
        path: "/servicios",
        element: <Servicios />,
      },
      {
        path: "/contacto",
        element: <Contacto />,
      },
      {
        path: "/galeria",
        element: <Galeria />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;